import React from 'react';
import { LogoMark } from './common/Logo';

const LoadingScreen = () => (
  <div className='loading-screen fixed left-0 top-0 z-[99999] flex h-full w-full flex-col items-center justify-center gap-5 bg-canvas'>
    <LogoMark size={72} />
    <span className='sr-only'>Loading</span>
  </div>
);

export default LoadingScreen;
